var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuroMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_322_352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2031 16.4885C17.7772 13.0627 12.2228 13.0627 8.79693 16.4885C5.37107 19.9144 5.37106 25.4688 8.79693 28.8947C12.2228 32.3205 17.7772 32.3205 21.2031 28.8947C24.6289 25.4688 24.6289 19.9144 21.2031 16.4885Z",
    stroke: "#34C6F1",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2031 16.4885L29.5004 8.19125",
    stroke: "#34C6F1",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2351 7.92616L23.708 7.31646",
    stroke: "#34C6F1",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7526 8.44309L30.3623 13.9702",
    stroke: "#34C6F1",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_322_352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.3566,
    height: 32.0907,
    fill: "white",
    transform: "translate(15 37.0859) rotate(-135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuroMale);
export default __webpack_public_path__ + "static/media/buroMale.8421675978a4de5fc4e1ff36b576f1dc.svg";
export { ForwardRef as ReactComponent };